import React from "react";
import "./warning_panel.scss";
// WarningPanelv2 is a redesign of our warning panel
const WarningPanelv2 = ({ children, level }) => {
  return <div className={"warning-panel-v2"}>{children}</div>;
};
export default WarningPanelv2;
